"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _reactRedux = require("react-redux");

require("./intl-polyfills");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var TranslationProvider = function TranslationProvider(props) {
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    var _state$translation;

    return (_state$translation = state.translation) !== null && _state$translation !== void 0 ? _state$translation : {
      locale: 'en-GB',
      messages: {}
    };
  }),
      _useSelector$locale = _useSelector.locale,
      locale = _useSelector$locale === void 0 ? 'en-GB' : _useSelector$locale,
      _useSelector$messages = _useSelector.messages,
      messages = _useSelector$messages === void 0 ? {} : _useSelector$messages;

  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
    var _state$user;

    return (_state$user = state.user) !== null && _state$user !== void 0 ? _state$user : {};
  }),
      _useSelector2$timezon = _useSelector2.timezone,
      timezone = _useSelector2$timezon === void 0 ? 'Europe/Berlin' : _useSelector2$timezon;

  var language = locale.substring(0, Math.max(2, locale.lastIndexOf('-')));
  return /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, _extends({}, props, {
    locale: locale,
    timeZone: timezone,
    messages: messages[language]
  }));
};

var _default = TranslationProvider;
exports["default"] = _default;